
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { ConsumiGestioneBC } from '@/components';
import { GruppoDistinte } from '@/models';
import { store } from '@/store';

@Component({
  components: {
    ConsumiGestioneBC
  }
})
export default class ItemListGruppoDistinteConsumi extends Vue {
  @Prop() private gruppo!: GruppoDistinte;

  get viewConsolidateIcon(){
    const filtro = store.state.uiConsumi.filtriDistinte;
    return this.gruppo.numDistinteConVariazioniConsolidate > 0 && 
      ((!filtro.soloDistinteDaValidare && !filtro.soloDistinteInDraft ) || filtro.soloDistinteValidateESincronizzate);
  }

  get viewDraftIcon(){
    const filtro = store.state.uiConsumi.filtriDistinte;
    return this.gruppo.numDistinteConVariazioniInDraft > 0 && 
      ((!filtro.soloDistinteDaValidare && !filtro.soloDistinteValidateESincronizzate ) || filtro.soloDistinteInDraft);
  }

    get viewInValidazioneIcon(){
    const filtro = store.state.uiConsumi.filtriDistinte;
    return this.gruppo.numDistinteConConsumiDaValidare > 0 && 
      ((!filtro.soloDistinteValidateESincronizzate && !filtro.soloDistinteInDraft ) || filtro.soloDistinteDaValidare);
  }

  get distinte(){
    const filtro = store.state.uiConsumi.filtriDistinte;
    var distinte = this.gruppo.distinte;

    if(filtro.idFornitore != undefined && 
        filtro.idFornitore != "" && 
        filtro.idFornitore.toLowerCase() != "bc"){
      distinte = distinte.filter(d => d.listaFornitoriAssociati.includes(filtro.idFornitore));
    }

    // if(filtro.soloDistinteDaValidare && filtro.soloDistinteInDraft){
    //   distinte = distinte.filter(d => d.contieneConsumiDaValidare || d.draft);
    // } else if(filtro.soloDistinteDaValidare){
    //   distinte = distinte.filter(d => d.contieneConsumiDaValidare);
    // } else if(filtro.soloDistinteInDraft){
    //   distinte = distinte.filter(d => d.draft);
    // }
    // // if(filtro.soloDistinteRifiutate){
    // //   distinte = distinte.filter(d => d.rifiutata);
    // // }

    if(filtro.soloDistinteDaValidare || filtro.soloDistinteInDraft || filtro.soloDistinteValidateESincronizzate){
      distinte = distinte.filter(d => {
        var result = false;
        if(filtro.soloDistinteDaValidare) result = result || d.contieneConsumiDaValidare;
        if(filtro.soloDistinteInDraft)    result = result || d.draft;
        if(filtro.soloDistinteValidateESincronizzate) result = result || d.contieneVariazioniConsolidate;
        return result;
      })
    }
    if(filtro.filtroStagioni != undefined && filtro.filtroStagioni.length > 0){
      distinte = distinte.filter(d => filtro.filtroStagioni.includes(d.idStagione));
    }
    if(filtro.filtroColori != undefined && filtro.filtroColori.length > 0){
      distinte = distinte.filter(d => filtro.filtroColori.includes(d.idColore));
    }
    if(filtro.filtroAvanzamentiProduzione != undefined && filtro.filtroAvanzamentiProduzione.length > 0){
      distinte = distinte.filter(d => filtro.filtroAvanzamentiProduzione.includes(d.avanzamentoProduzione));
    }
    if(filtro.filtroLineeVendita != undefined && filtro.filtroLineeVendita.length > 0){
      distinte = distinte.filter(d => filtro.filtroLineeVendita.includes(d.lineaVendita));
    }

    if(filtro.filtroVariazioniDaData && filtro.filtroVariazioniAData){
      distinte = distinte
        .filter(d => d.dateVariazioni.some(
          data => (filtro.filtroVariazioniDaData || new Date()) <= new Date(Date.parse(data)) &&
            new Date(Date.parse(data)) <= (filtro.filtroVariazioniAData || new Date())));
    } else if(filtro.filtroVariazioniDaData){
      distinte = distinte.filter(d => d.dateVariazioni.some(data => (filtro.filtroVariazioniDaData || new Date()) <= new Date(Date.parse(data))));
    } else if(filtro.filtroVariazioniAData){
      distinte = distinte.filter(d => d.dateVariazioni.some(data => (filtro.filtroVariazioniAData || new Date()) >= new Date(Date.parse(data))));
    }

    distinte = distinte.filter(d => !d.eliminataDaAs400);

    this.gruppo.distinte = distinte;
    return distinte;
  }
  private showDistinte: boolean = false;

  private toggleShowDistinte() {
    this.showDistinte = !this.showDistinte;
  }
}
